<div id="autocomplete-wrapper">
  <div id="autocomplete-input">
    @if (selectedTags.length > 0) {
      <div class="tags-wrapper">
        @for (tag of selectedTags; track tag; let i = $index) {
          <span class="tag">
            {{ tag }}
            <span
              class="tag-close"
              (click)="removeTag(tag)"
              (keydown.enter)="removeTag(tag)"
              >×</span
            >
          </span>
        }
      </div>
    }
    <textarea
      #autoCompleteInput
      name="question"
      id="inputField"
      [placeholder]="placeholderText"
      (keyup)="onKeypressEvent($event)"
      (keydown.enter)="onEnterKeyDown($event)"
      [(ngModel)]="singleTag"
      type="text"
      autocomplete="off"
      ariea-multiple="true"
    >
    </textarea>
  </div>
  @if (suggestionEnable) {
    <div id="suggestion-list" [hidden]="!showSearches">
      <div class="search">
        @for (data of searchedList; track trackById($index, data)) {
          <div
            (click)="setSelected(data)"
            (keydown.enter)="setSelected(data)"
            class="search-result"
            [innerHTML]="data | searchHighlight: singleTag"
          ></div>
        }
      </div>
      @if (searchedList.length == 0 && singleTag != "") {
        <p class="search">No Data found</p>
      }
    </div>
  }
  <div class="tools">
    <span class="icon" (click)="sendSearch()" (keydown.enter)="sendSearch()"
      ><i class="bi bi-send"></i
    ></span>
  </div>
</div>
